'use strict';
import * as $j_app$002edata$002e$002dPush$002dNotification$002dData from "./app.data.-Push-Notification-Data.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_GeneralPracticeAppUpdate$$anon$81(evaluator$39) {
  this.Lapp_api_GeneralPracticeAppUpdate$$anon$81__f_evaluator$15 = null;
  this.Lapp_api_GeneralPracticeAppUpdate$$anon$81__f_evaluator$15 = evaluator$39;
}
export { $c_Lapp_api_GeneralPracticeAppUpdate$$anon$81 as $c_Lapp_api_GeneralPracticeAppUpdate$$anon$81 };
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$81.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$81.prototype.constructor = $c_Lapp_api_GeneralPracticeAppUpdate$$anon$81;
/** @constructor */
function $h_Lapp_api_GeneralPracticeAppUpdate$$anon$81() {
}
export { $h_Lapp_api_GeneralPracticeAppUpdate$$anon$81 as $h_Lapp_api_GeneralPracticeAppUpdate$$anon$81 };
$h_Lapp_api_GeneralPracticeAppUpdate$$anon$81.prototype = $c_Lapp_api_GeneralPracticeAppUpdate$$anon$81.prototype;
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$81.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$81.prototype.apply__s_Option = (function() {
  var v = this.Lapp_api_GeneralPracticeAppUpdate$$anon$81__f_evaluator$15.apply__O();
  return ((v instanceof $j_app$002edata$002e$002dPush$002dNotification$002dData.$c_Lapp_data_PushNotificationData) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$81.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_api_GeneralPracticeAppUpdate$$anon$81 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_GeneralPracticeAppUpdate$$anon$81, "app.api.GeneralPracticeAppUpdate$$anon$81", ({
  Lapp_api_GeneralPracticeAppUpdate$$anon$81: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_GeneralPracticeAppUpdate$$anon$81 as $d_Lapp_api_GeneralPracticeAppUpdate$$anon$81 };
//# sourceMappingURL=app.api.-General-Practice-App-Update$$anon$81.js.map
